// extracted by mini-css-extract-plugin
export default {"inlineOops":"InlineOops_inlineOops__W7C9k"};